import { EventAnimationSvg as e } from "./EventAnimation.styled.mjs";
import t from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { EV_ENTER as i, evSceneEnd as a, resolveEventName as o, resolveEventScene as s } from "@maat/assets";
//#region src/components/EventAnimation/EventAnimation.tsx
var c = (e) => {
	let t = {};
	if (e.enter) {
		let { preset: n, at: r, dur: a, tx: o, ty: s, rot: c, len: l } = e.enter;
		t["--t"] = `${r}ms`, a !== void 0 && a !== i[n].dur && (t["--d"] = `${a}ms`), o !== void 0 && (t["--tx"] = `${o}px`), s !== void 0 && (t["--ty"] = `${s}px`), c !== void 0 && (t["--rot"] = `${c}deg`), l !== void 0 && (t["--len"] = l);
	}
	return e.anim?.delay && (t["--dl"] = `${e.anim.delay}ms`), e.origin && (t.transformOrigin = `${e.origin[0]}px ${e.origin[1]}px`), Object.keys(t).length ? t : void 0;
}, l = (e) => typeof e == "object" ? e.join(" ") : e, u = (e) => ({
	fill: e.fill,
	opacity: e.opacity,
	transform: e.transform,
	stroke: e.stroke,
	strokeWidth: e.strokeWidth,
	strokeLinecap: e.strokeLinecap,
	strokeLinejoin: e.strokeLinejoin,
	strokeDasharray: l(e.strokeDasharray),
	strokeDashoffset: e.strokeDashoffset,
	className: [e.enter && `e-${e.enter.preset}`, e.anim && `i-${e.anim.key}`].filter(Boolean).join(" ") || void 0,
	style: c(e)
}), d = (e, t, i, a = "") => {
	let o = `${a}-${t}`, s = u(e);
	switch (e.kind) {
		case "path": return /* @__PURE__ */ n("path", {
			...s,
			d: e.d
		}, t);
		case "rect": return /* @__PURE__ */ n("rect", {
			...s,
			x: e.x,
			y: e.y,
			width: e.width,
			height: e.height,
			rx: e.rx
		}, t);
		case "circle": return /* @__PURE__ */ n("circle", {
			...s,
			cx: e.cx,
			cy: e.cy,
			r: e.r
		}, t);
		case "ellipse": return /* @__PURE__ */ n("ellipse", {
			...s,
			cx: e.cx,
			cy: e.cy,
			rx: e.rx,
			ry: e.ry
		}, t);
		case "g": {
			let a = e.children.map((e, t) => d(e, t, i, o));
			if (!e.clip) return /* @__PURE__ */ n("g", {
				...s,
				children: a
			}, t);
			let c = `evc${i}${o}`;
			return /* @__PURE__ */ r("g", {
				...s,
				children: [/* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
					id: c,
					children: /* @__PURE__ */ n("rect", {
						x: e.clip.x,
						y: e.clip.y,
						width: e.clip.width,
						height: e.clip.height,
						rx: e.clip.rx
					})
				}) }), /* @__PURE__ */ n("g", {
					clipPath: `url(#${c})`,
					children: a
				})]
			}, t);
		}
		default: return null;
	}
}, f = ({ name: r, width: i, playKey: c, motion: l = !0, color: u, className: f }) => {
	let p = o(r), m = s(r), h = a(p), g = t.useId().replace(/[^a-zA-Z0-9]/g, ""), [_, v] = t.useState(l);
	t.useEffect(() => {
		if (!l) {
			v(!1);
			return;
		}
		v(!0);
		let e = setTimeout(() => v(!1), h);
		return () => clearTimeout(e);
	}, [
		c,
		h,
		l
	]);
	let y = i ?? m.width, b = [
		_ ? "pl" : void 0,
		l && m.idle ? "id" : void 0,
		f
	].filter(Boolean).join(" ");
	return /* @__PURE__ */ n(e, {
		viewBox: `${m.x ?? 0} ${m.y ?? 0} ${m.width} ${m.height}`,
		width: y,
		height: y * (m.height / m.width),
		className: b || void 0,
		style: u ? { color: u } : void 0,
		"aria-hidden": "true",
		focusable: "false",
		children: m.nodes().map((e, t) => d(e, t, g))
	});
};
//#endregion
export { f as EventAnimation };
